/* eslint key-spacing: 'off', comma-spacing: 'off' */
import common from '@/scripts/common';
import commonModelHelper from '@/scripts/commonModelHelper';
import current from '@/scripts/current'
import modelHelper from '@/scripts/crossTabulation/modelHelper';
import VariableSelection from '@/bo/VariableSelection';
import store from '@/store';

export default {
    getLoadTime: function (selectedRecordCount) {
        var v = current.selectionModel.v;
        var model = {
            NumberOfRecords: selectedRecordCount,
            ControlLevels: commonModelHelper.getNumberOfLevels(v.control1) * commonModelHelper.getNumberOfLevels(v.control2),
            RowAndColumnLevels: commonModelHelper.getNumberOfLevels(v.row) * commonModelHelper.getNumberOfLevels(v.column),
            NumberOfYears: store.state.selModel.years.values.length
        };
        var milliseconds = model.NumberOfYears > 1 ?
            (0.032119 * model.NumberOfRecords) + (1166.819579 * model.ControlLevels) + (789.049212 * model.RowAndColumnLevels) :
            (0.024070 * model.NumberOfRecords) + (631.924962 * model.ControlLevels) + (294.689461 * model.RowAndColumnLevels);
        milliseconds *= 0.9; //It is running faster due to server speed, so decrease the # of seconds
        //milliseconds *= 1.5;// Make it larger so that it returns quicker than the user expects
        //

        let seconds = Math.ceil(milliseconds / 1000);

        //Divide by 3 for QA and Prod
        return seconds;
    },
    isValid: {
        years: function () {
            switch (store.state.selModel.years.selectionType) {
                case 'single':
                    return store.state.selModel.years.single > 0;
                case 'combine':
                case 'compare':
                    return store.state.selModel.years.values.length >= 2;
                default:
                    return false;
            }
            //return store.state.selModel.years.single > 0 || store.state.selModel.years.values.length >= 2;
        },
        location: function (model) {
            return store.state.selModel.locations.isSet;
        },
        rowvariable: function (selectionModel) {
            return selectionModel.v.row.isSelected();
        },
        columnvariable: function (model) {
            return current.selectionModel.v.column.isNotIncludedOrSelected();
        },
        controlvariables: function (model) {
            //console.log('control2 12', current.selectionModel.v.control2.include, current.selectionModel.v.control2);
            return current.selectionModel.v.control1.isNotIncludedOrSelected() &&
                current.selectionModel.v.control2.isNotIncludedOrSelected();
        },
        statistics: function (model) {
            var statistics = model.selectedStatistics;
            return statistics.sampleSize || statistics.chiSquare ||
                current.modelHelper.statisticInGroupSelected(statistics.rowPercentage) ||
                current.modelHelper.statisticInGroupSelected(statistics.columnPercentage) ||
                current.modelHelper.statisticInGroupSelected(statistics.totalPercentage) ||
                current.modelHelper.statisticInGroupSelected(statistics.weightedN);

        },
        viewreport: function (model) {
            return true;
        }
    },
    makeModelValid: function () {
        var v = current.selectionModel.v;
        if (v.row === undefined || v.row === null)
            v.row = VariableSelection.newNotIncluded();
        if (v.column === undefined || v.column === null)
            v.column = VariableSelection.newIncluded();
        if (v.control1 === undefined || v.control1 === null)
            v.control1 = VariableSelection.newNotIncluded();
        //console.log('control2 10', current.selectionModel.v.control2.include, current.selectionModel.v.control2);
        if (v.control2 === undefined || v.control2 === null)
            v.control2 = VariableSelection.newNotIncluded();
        //console.log('control2 11', current.selectionModel.v.control2.include, current.selectionModel.v.control2);
    },
    modelIsComplete: function (model, currentStep) {
        var isValid = true;
        var stepIndex = current.navigation.stepIndex[currentStep];
        if (stepIndex >= current.navigation.stepIndex.years)
            isValid = isValid && current.modelHelper.isValid.years();
        if (stepIndex >= current.navigation.stepIndex.location)
            isValid = isValid && current.modelHelper.isValid.location();
        if (stepIndex >= current.navigation.stepIndex.rowvariable)
            isValid = isValid && current.modelHelper.isValid.rowvariable(model);
        if (stepIndex >= current.navigation.stepIndex.columnvariable)
            isValid = isValid && current.modelHelper.isValid[current.navigation.step.columnvariable](model);
        if (stepIndex >= current.navigation.stepIndex.controlvariables)
            isValid = isValid && current.modelHelper.isValid[current.navigation.step.controlvariables](model);
        if (stepIndex >= current.navigation.stepIndex.statistics)
            isValid = isValid && current.modelHelper.isValid[current.navigation.step.statistics](model);
        return isValid;
    },
    statisticInGroupSelected: function (statisticGroup) {
        return statisticGroup.value || statisticGroup.standardError || statisticGroup.confidenceInterval;
    },
    getAllowedSelections: function (variableType, omittedVariables) {
        var comparingYears = store.state.selModel.years.selectionType === 'compare';
        var comparingLocations = store.state.selModel.locations.selectionType === 'compare';
        var selections = {
            year: comparingYears && (omittedVariables === null || !omittedVariables.year),
            location: comparingLocations && (omittedVariables === null || !omittedVariables.location),
            variable: true,
            count: 0,
            comparingYears: comparingYears,
            comparingLocations: comparingLocations,
            isRequired: false,
            isAllowed: variableType === 'control2' ? current.selectionModel.v.control1.isSelected() : true,
            defaultType: null
        };
        if (variableType === 'control1' && (selections.year && selections.location) ||
            (variableType === 'control2' && (selections.year || selections.location)))
            selections.variable = false;
        selections.count = (selections.year ? 1 : 0) + (selections.location ? 1 : 0) + (selections.variable ? 1 : 0);
        if (selections.count === 1)
            selections.defaultType = selections.year ? 'year' : (selections.location ? 'location' : 'variable');
        selections.isRequired = variableType === 'row' || selections.year || selections.location;

        return selections;
    },
    setDefaultStatistics: function () {
        var statistics = current.selectionModel.selectedStatistics;
        var hasColumn = current.selectionModel.v.column.include;

        //Make sure that all stats are correct, as there has been a bug in this area causing the "hasColumn" stats not to be selected
        if (statistics.isSet && statistics.chiSquare === hasColumn && statistics.columnPercentage === hasColumn && statistics.totalPercentage === hasColumn)
            return true;
        current.selectionModel.selectedStatistics = {
            isSet: true,
            sampleSize: true,  //unweighted frequency
            chiSquare: hasColumn,
            standardError: false,
            confidenceInterval: true,
            rowPercentage: true,
            columnPercentage: hasColumn,
            totalPercentage: hasColumn,
            weightedN: false,
            nonResponse: false
        };
    },
    setMinimalStatistics: function () {
        var hasColumn = current.selectionModel.v.column.include;
        current.selectionModel.selectedStatistics = {
            isSet: true,
            sampleSize: true,  //unweighted frequency
            chiSquare: hasColumn,
            standardError: false,
            confidenceInterval: false,
            rowPercentage: true,
            columnPercentage: hasColumn,
            totalPercentage: hasColumn,
            weightedN: false,
            nonResponse: false
        };
    },
    setAllStatistics: function (options) {
        //console.log('setAllStatistics', options)
        let standardError = options && options.standardError == false ? false : true;
        let confidenceInterval = options && options.confidenceInterval == false ? false : true;
        let weightedN = options && options.weightedN == false ? false : store.state.selModel.years.values.length < 2;
        let nonResponse = options && options.nonResponse == false ? false : true;

        var statistics = current.selectionModel.selectedStatistics;
        var hasColumn = current.selectionModel.v.column.include;
        //Make sure that all stats are correct, as there has been a bug in this area causing the "hasColumn" stats not to be selected
        if (statistics.isSet && statistics.chiSquare === hasColumn && statistics.columnPercentage === hasColumn && statistics.totalPercentage === hasColumn)
            return true;
        current.selectionModel.selectedStatistics = {
            isSet: true,
            sampleSize: true,  //unweighted frequency
            chiSquare: hasColumn,
            standardError,
            confidenceInterval,
            rowPercentage: true,
            columnPercentage: hasColumn,
            totalPercentage: hasColumn,
            weightedN,
            nonResponse
        };
    },
    resetAllValues: function () {
        commonModelHelper.resetYear();
        commonModelHelper.resetLocation();
        current.selectionModel.v.row = VariableSelection.newNotIncluded();
        current.selectionModel.v.column = VariableSelection.newIncluded();
        current.selectionModel.v.control1 = VariableSelection.newNotIncluded();
        current.selectionModel.v.control2 = VariableSelection.newNotIncluded();
        current.selectionModel.selectedStatistics.isSet = false;
    },
    resetValuesForCurrentStep: function (currentStep) {
        var stepIndex = current.navigation.stepIndex[currentStep];
        if (stepIndex < current.navigation.stepIndex.years)
            commonModelHelper.resetYear();
        if (stepIndex < current.navigation.stepIndex.location)
            commonModelHelper.resetLocation();
        if (stepIndex < current.navigation.stepIndex.rowvariable)
            current.selectionModel.v.row = VariableSelection.newNotIncluded();
        if (stepIndex < current.navigation.stepIndex.columnvariable)
            current.selectionModel.v.column = VariableSelection.newNotIncluded();
        if (stepIndex < current.navigation.stepIndex.controlvariables) {
            current.selectionModel.v.control1 = VariableSelection.newNotIncluded();
            current.selectionModel.v.control2 = VariableSelection.newNotIncluded();
        }
        // commonModelHelper.resetVariableControl(stepIndex, current.navigation.stepIndex.rowvariable, 'row', omittedVariables, true);
        // commonModelHelper.resetVariableControl(stepIndex, current.navigation.stepIndex.columnvariable, 'column', omittedVariables, true);
        // commonModelHelper.resetVariableControl(stepIndex, current.navigation.stepIndex.controlvariables, 'control1', omittedVariables, false);
        // commonModelHelper.resetVariableControl(stepIndex, current.navigation.stepIndex.controlvariables, 'control2', omittedVariables, false);
        if (stepIndex < current.navigation.stepIndex.statistics)
            current.selectionModel.selectedStatistics.isSet = false;
        else
            current.modelHelper.setDefaultStatistics();
    },
    isYearTotal(variable, level) {
        var levelId = level ? level.id : 0;
        var variableSelection = current.selectionModel.v[variable];
        return variableSelection.include && variableSelection.type === 'year' && levelId === 0;
    }
}

// function resetVariableControl(stepIndex, variableStepIndex, variableType, omittedVariables, isEnabled) {
//   if (stepIndex < variableStepIndex || (stepIndex === variableStepIndex && !current.selectionModel.v[variableType]))
//     current.selectionModel.v[variableType] = VariableSelection.newNotIncluded();
// }